export const DBRoleConstants = {
    FETCHING: 'FETCHING',
    FETCHED: 'FETCHED',
    GET_DBROLE: 'GET_DBROLE',
}